module.exports = __webpack_public_path__ + "img/二维码中山.a58cc573.png";